import { Paper, PaperProps } from '@mui/material'
import Draggable from 'react-draggable'
import { ReactElement } from 'react'

const PaperModalComponent = (props: PaperProps): ReactElement => (
    <Draggable handle="#draggable-modal-title">
        <Paper
            {...props}
            style={{
                width: '100%',
                position: 'absolute',
                top: '50%',
                left: '0%',
            }}
        />
    </Draggable>
)

export default PaperModalComponent
